import React from "react";
import * as s from "../../auth/signup/SignupStyled";

export default function StatementPolicy() {
  return (
    <s.EULAText>
      We use cookies and similar technologies to enhance user experience,
      analyze traffic, and personalize content.
      <br />
      <br />
      Cookies are categorized as:
      <br />
      - Necessary
      <br />
      - Functional
      <br />
      - Analytics
      <br />
      - Advertisement
      <br />
      <br />
      Third-party services include:
      <br />
      Google Analytics, Google Tag Manager, etc.
      <br />
      <br />
      Users have rights under GDPR/CCPA including access, deletion, and opt-out.
      <br />
      <div className="cky-audit-table-element"></div>
    </s.EULAText>
  );
}
